@if (chartDataSet) {
<chart data-testid="generic-chart"
  [dataSet]="chartDataSet"
  [title]="chartConfiguration.title"
  [chartType]="chartConfiguration.chartType"
  [options]="chartOptions()">
</chart>
}
